import React from 'react';
import { Layout } from 'components/Layout';
import { Top } from 'components/Top';
import { Bottom } from 'components/Bottom';
import { Helmet } from 'react-helmet';
import { FaPhoneAlt, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { MdLocationOn } from 'react-icons/md';
import {
  Container,
  Contacts,
  ContactContent,
  Box,
  Location,
  LocationInfo,
} from './styles'

const Contact = () => (
  <Layout>
    <Helmet title="LCK - Produtos" />
    <Top />
    <Container>
      <h1>
        CONSULTE NOSSOS PREÇOS E CONDIÇÕES
      </h1>

      <Contacts>

        <ContactContent>
          <FaPhoneAlt />
          <div>
            Contato:<br />
            (11) 2412-0008
          </div>
        </ContactContent>

        <ContactContent>
          <FaEnvelope />
          <div>
            Comercial:<br />
            lck.importacao@gmail.com
          </div>
        </ContactContent>
        </Contacts>

        <Contacts>

        <ContactContent>
          <FaWhatsapp />
          <div>
            Vendas:<br />
            <a 
              href="https://wa.me/5511941817158?text=Olá!"
              target="_blank"
              rel="noreferrer">
              (11) 9 4181-7158
            </a>
          </div>
        </ContactContent>

        <ContactContent>
        </ContactContent>
      </Contacts>
      <Box>
        Excelentes condições de pagamento, preços competitivos e a
        entrega mais rápida da região. Garanta o giro dos seus produtos!
      </Box>

      <Location>
        <LocationInfo>
          <MdLocationOn />
          <div>
            <span>Endereço:</span>
            <span>Rua Ribeirão Branco, 116 - anexo 102</span>
            <span>Vila Bertioga - São Paulo - SP</span>
            <span>CEP: 03188-050</span>
          </div>
        </LocationInfo>

        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.1078517804035!2d-46.57994192386097!3d-23.564569661711662!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce5ea0e433cf2f%3A0x5e06f9f72388f352!2sR.%20Ribeir%C3%A3o%20Branco%2C%20116%20-%20%C3%81gua%20Rasa%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2003188-050!5e0!3m2!1spt-BR!2sbr!4v1705331149892!5m2!1spt-BR!2sbr" 
          title="LCK"
          width="100%"
          height="450"
          frameBorder="0"
          allowfullscreen=""
          loading="lazy" 
          referrerpolicy="no-referrer-when-downgrade"></iframe>
      </Location>
    </Container>

    <Bottom />
  </Layout>
)

export default Contact 
